import { Modal, Space } from "antd";
import type { HookAPI } from "antd/es/modal/useModal";
import type { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";

type Props = {
  icon?: ReactNode;
  textIntlKey?: string;
  handleConfirm?: (modal: HookAPI) => void;
  handleDelete: () => void;
  loading?: boolean;
  itemName: string;
};

export const TableRowActionDelete = ({ icon, textIntlKey, handleConfirm, handleDelete, loading, itemName }: Props) => {
  const [modal, contextHolder] = Modal.useModal();
  const { formatMessage } = useIntl();
  const onClickHandler = () => {
    if (handleConfirm) {
      handleConfirm(modal);
    } else {
      modal.confirm({
        title: formatMessage({ id: "delete" }),
        content: formatMessage({ id: "delete.confirm" }, { item: itemName }),
        okText: formatMessage({ id: "delete" }),
        okButtonProps: { loading: loading },
        onOk: () => handleDelete(),
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Space onClick={onClickHandler}>
        {icon ? icon : <i className="fas fa-trash-can mr-2" />}
        {<FormattedMessage id={textIntlKey || "delete"} />}
      </Space>
    </>
  );
};
